<template>
  <div class="flexRowClass logoContainer" >
    <div style="padding-top: 15px">
      <img :src="showLogo" style="height: 60px;">
    </div>
    <div style="margin-left: 10px;color: #FFFFFF;z-index: 100;font-size: 22px; font-weight: 600;">
      {{ showTitle }}
    </div>
  </div>
</template>

<script>

import logo from '@@/assets/logo.png'

export default {
  computed: {
    showLogo() {
      // console.log('this.$store.state', this.$store.state)
      return this.$store.state.platformInfo.platformLog || logo
    },
    showTitle() {
      return this.$store.state.platformInfo.platformName || '鄂尔多斯市国有企业阳光采购平台'
    }
  }
}
</script>

<style scoped>

.logoContainer {
  height: 100px;
  line-height: 100px;
}

</style>